module.exports = __webpack_public_path__ + "static/media/tm.60150d65.svg";